import { Close } from '@mui/icons-material';
import {
  Alert,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import { useState } from 'react';

export default function ConsultantRemove({ open, onClose, facilityId, consultant }) {
  const [saving, setSaving] = useState(false);

  return (
    <Dialog open={open} maxWidth="sm" fullWidth>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
          Remove Consultant
        </DialogTitle>
        <Box ml="auto" px={3}>
          <IconButton onClick={() => onClose()} disabled={saving}>
            <Close />
          </IconButton>
        </Box>
      </Box>
      <DialogContent>
        <Alert severity="info" icon={false}>
          {`You are about to remove this Consultant from your Facility`}
        </Alert>
        <br />
        <Typography variant='body2'>{`If you do this, they will no longer consult for your facility. Note that System Administrator will review this before action is completed`}</Typography>
      </DialogContent>
      <DialogActions sx={{ px: 2, pb: 2 }}>
        <Button
          type="button"
          variant="contained"
          color="info"
          //disabled={sending}
          //   startIcon={!sending ? <Add /> : <CircularProgress size={20} />}
          //   onClick={handleSendInvite}
          sx={{ textTransform: 'none', borderRadius: 20 }}
        >
          Yes, Remove
        </Button>
      </DialogActions>
    </Dialog>
  );
}
